<template>
  <v-container fill-height style="max-width: 500px;">
    <v-layout row wrap align-center>
      <v-flex class="text-xs-center">
        <v-card>
          <v-card-text>
            <div class="display-1">
              Logging out...
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import { loginRoute } from '@/lib/constants/routes'

export default {
  methods: {
    ...mapActions('authentication', [
      'logout'
    ])
  },
  created () {
    this.logout().then(() => {
      this.$router.push(loginRoute.url)
      this.$store.replaceState(JSON.parse(JSON.stringify(this.$initialStateCopy)))
    })
  }
}
</script>

<style>

</style>
